import moment from 'moment';
import 'moment/locale/ru';

export function periodB(period: number, t: any) {
  const duration = moment.duration(period, 'seconds');

  if (duration.asMinutes() > 1439) {
    return Math.ceil(duration.asDays()).toString() + ' ' + t('days');
  }

  if (duration.asMinutes() > 59) {
    return Math.ceil(duration.asHours()).toString() + ' ' + t('hours');
  }

  return Math.ceil(duration.asMinutes()).toString() + ' ' + t('minutes');
}

export function beautifyDate(d: string, lng: string): string {
  const date = moment(d).locale(lng);
  if (
    moment(d).add(1, 'day').toDate() < new Date() ||
    moment(d).subtract(1, 'day').toDate() > new Date()
  ) {
    return date.format(
      `${lng === 'ru' ? 'DD.MM.YYYY' : 'MM.DD.YYYY'} [${lng === 'ru' ? 'в' : 'at'}] H:mm`,
    );
  } else if (
    moment(d).add(1, 'hour').toDate() < new Date() ||
    moment(d).subtract(1, 'hour').toDate() > new Date()
  ) {
    return date.calendar().toString();
  } else {
    return date.fromNow().toString();
  }
}

export function month(lng: string) {
  const date = moment(new Date()).locale(lng).format('MMMM').toString();
  return date.charAt(0).toUpperCase() + date.slice(1);
}

export function durationAsHours(seconds: number, lng: string) {
  return Math.floor(moment.duration(seconds, 'seconds').asHours());
}
